import styled from 'styled-components';
import media from '../../oldpantheon/utils/media';
import { BLACK, GRAY, LIGHT_GRAY } from '../../theme';
import Select from '../../oldpantheon/components/Select';

export const PageHeader = styled.h1`
  font-size: 2rem;
  margin-bottom: 0.625rem;
  margin-top: 0rem;

  ${media.extraSmall`
    font-size: 1.5rem;
    margin-bottom: 0rem;
  `}
`;

export const PageWrapper = styled.div`
  width: 90%;
  max-width: 50rem;
  margin: 0 auto;
`;

export const PageSubtitle = styled.div`
  font-family: "PT Serif";
  font-size: 1.125rem;
  color: ${BLACK};

  ${media.extraSmall`
    font-size: 1rem;
  `}
`;

export const CompatibilityIcon = styled.img`
  margin-right: 1.25rem;
  height: 8.125rem;
  width: auto;

  ${media.extraSmall`
    height: 4.375rem;
    width: auto;
  `}
`;

export const FullHeaderWrapper = styled.div`
  display: flex;
  margin-top: 1.5rem;

  ${media.extraSmall`
    margin-bottom: 1.9rem;
    `}
`;

export const InputTitle = styled.div`
  font-family: "Calistoga";
  font-size: 1.25rem;
  color: ${BLACK};

  ${media.extraSmall`
    display: none;
  `}
`;

export const InputWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  margin-bottom: 2.2rem;

  ${media.extraSmall`
    flex-direction: column;
    margin-bottom: 1.5rem;
    `}
`;

export const StyledSelect = styled(Select)`
  background-color: ${LIGHT_GRAY};
  border: 2px solid ${GRAY};
  border-radius: 1.5rem;
  top: 0.625rem;

  color: ${BLACK};
  font-size: 1rem;
  padding: 0 1rem;
  margin-bottom: .5rem;
  height: 2.8rem;
  width: 100%;

  ${media.extraSmall`
    width: 100%;
    `}

    Select {
      position: absolute;
      top: 0.25rem;
    }
`;

export const SingleInputWrapper = styled.div`
  width: 40%;

  ${media.extraSmall`
    width: 100%;
    `}
`;

export const HeartCompatibilityIcon = styled.img`
  height: 2.2rem;
  width: auto;

  ${media.extraSmall`
    display: none;
    `}
`;

export const InfoTitle = styled.h2`
  font-size: 1.5rem;
  color: ${BLACK};
  font-family: "Calistoga";
  margin-bottom: 0.9rem;
  text-align: ${(props) => props.center ? `center` : `left`};
`;

export const InfoBodyCopy = styled.p`
  line-height: 1.75rem;
  font-size: 1rem;
  margin-bottom: 2rem;
  color: ${BLACK};
`;

export const ChosenSigns = styled.div`
  font-family: "PT Serif";
  font-size: 1.25rem;
  text-align: center;
  margin-top: 2.2rem;
`;

export const ChosenSignImg = styled.img`
  width: 9.375rem;
  height: auto;

  ${media.extraSmall`
    width: 6.25rem;
    height: auto;
    `}
`;

export const CompatibilityInfo = styled.div`
  line-height: 1.75rem;
  font-size: 1rem;
  margin-bottom: 0.625rem;
  color: ${BLACK};
`;

export const CompatibilityIconSimple = styled.img`
  padding: 0 0.9rem;
`;

export const SignImagesWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const HelpBlock = styled.p`
  color: ${(props) => props.validationState ? `green` : `red`};
  margin: 0 0 1rem 0;
  text-align: center;
`;

export const SignTableTitle = styled.div`
  font-family: Calistoga;
  color: ${BLACK};
  font-size: 1.25rem;
  text-align: center;
  margin-top: 3.125rem;
`;
